module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"compare_period":"Comparison Period"}}')
  delete Component.options._Ctor
}
